<template>
  <sui-page-contents>
    <div class="mrB30" />
      <sui-grid ref="grid"
      :hideHeader="hideHeader"
      :autoheight="autoheight"
      :multiselect="multiselect"
      :showCountControl="showCountControl"
      :showDisplayCountControl="showDisplayCountControl"
      :showMoveControl="showMoveControl"
      :sortable="sortable" :filterable="filterable" :columns="gridColumns0" :dataset="'dataset0'">
      </sui-grid>
      <div class="row">
        <sui-checkbox v-model="multiselect">multiselect</sui-checkbox>
        <sui-checkbox v-model="hideHeader">hideheader</sui-checkbox>
        <sui-checkbox v-model="showCountControl">showCountControl</sui-checkbox>
        <sui-checkbox v-model="showDisplayCountControl">showDisplayCountControl</sui-checkbox>
        <sui-checkbox v-model="showMoveControl">showMoveControl</sui-checkbox>
        <sui-checkbox v-model="autoheight">autoheight</sui-checkbox>
      </div>
    </div>
  </sui-page-contents>
</template>
<script>
  import LangSelect from '~common/components/form/SuiLangSelect/SuiLangSelect';
  export default {
    name: 'DatasetWithComponent',
    data() {
      return {
        hideHeader: false,
        autoheight: false,
        sortable: true,
        filterable: true,
        showCountControl: true,
        showDisplayCountControl: true,
        showMoveControl: true,
        multiselect: false,
        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        gridColumns0: [
          {
              text: 'rowId',
              datafield: 'dataset-row-id',
              width: '50px',
          },
          {
            text: '버튼',
            datafield: 'buttonList',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
                handler: this.onGridButtonClicked
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '200px',
          },
          {
            text: '페이지 명',
            datafield: 'pageName',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
                trim: true,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: '페이지 상태',
            datafield: 'pageStatusCode',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
                optionList: this.customOptions,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          // {
          //   text: '멀티 셀렉트',
          //   datafield: 'multiselect',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellMultiSelect(row, column, value, htmlElement, {
          //       options: this.multiSelectOptions,
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          // },
          {
            text: '진행 상태',
            datafield: 'state',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: 100,
          },
          {
            text: '사용여부',
            datafield: 'pageUseYn',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: '삭제여부',
            datafield: 'deleteYn',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          // {
          //   text: '수정일시',
          //   datafield: 'pageUsePriodStartDatetime',
          //   createwidget: (row, column, value, htmlElement) => {
          //     const editorInstance = utils.getGridCellFactory().createCellDatePicker(row, column, value, htmlElement, {
          //       items: [{key: 'Y', label: 'Yes'}, {key: 'N', label: 'No'}],
          //     }, this.dataset0, this.$refs.grid);
          //   },
          //   initwidget(row, column, value, htmlElement) {
          //     utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
          //   },
          //   width: 300,
          // }
        ],
        localdata0: [{
            "deleteYn": "Y",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00001",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00001",
            "pageId": "PGE_CMS_00000",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "Y",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-10",
            "pageUsePriodFinishDatetime": "9999-12-31",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-10~2019-02-15',
            'buttonList': [{
              label: 'btn01',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn02',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn01',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '11:52',
            'state': {
              type: 'complete',
              label: '완료'
            },
            'multiselect': ['item01', 'item02'],
          },
          {
            "deleteYn": "Y",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00003",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00003",
            "pageId": "PGE_CMS_00001",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "N",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-11",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-11~2019-02-16',
            'buttonList': [{
              label: 'btn21',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn22',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn23',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '12:12',
            'state': {
              type: 'waiting',
              label: '대기'
            },
            'multiselect': ['item01', 'item03'],
          },
          {
            "deleteYn": "N",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00005",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00005",
            "pageId": "PGE_CMS_00002",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "Y",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-13",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-12~2019-02-17',
            'buttonList': [{
              label: 'btn33',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn32',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn01',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '14:52',
            'state': {
              type: 'cancel',
              label: '취소'
            },
            'multiselect': ['item02', 'item04'],
          },
          {
            "deleteYn": "N",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00002",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00002",
            "pageId": "PGE_CMS_00003",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "N",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-14",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-14~2019-02-18',
            'buttonList': [{
              label: 'btn44',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn42',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn01',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '17:17',
            'state': {
              type: 'complete',
              label: '완료'
            },
            'multiselect': ['item03'],
          },
        ],
      };
    },
    mounted() {
      const newData = [];
      for (let i = 0; i < 3; i++) {
        this.localdata0.forEach(data => {
          newData.push(_.clone(data));
        });
      }
      this.dataset0.setRawData(newData);
      // this.dataset0.$on(this.dataset0.EVENTS.DATA_CHANGED, this.datasetUpdate);
      // this.dataset0.$on(this.dataset0.EVENTS.DATAFIELDS_CHANGED, this.datasetUpdate);
      // this.dataset0.$on(this.dataset0.EVENTS.RAW_DATA_CHANGED, this.datasetUpdate);
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [{
          "name": "deleteYn",
          "type": "string",
          "map": "deleteYn"
        },
        {
          "name": "firstRegistrationDTM",
          "type": "string",
          "map": "firstRegistrationDTM"
        },
        {
          "name": "firstRegistrationUserId",
          "type": "string",
          "map": "firstRegistrationUserId"
        },
        {
          "name": "firstRegistrationProgramId",
          "type": "string",
          "map": "firstRegistrationProgramId"
        },
        {
          "name": "finalModificationDTM",
          "type": "string",
          "map": "finalModificationDTM"
        },
        {
          "name": "finalModificationUserId",
          "type": "string",
          "map": "finalModificationUserId"
        },
        {
          "name": "finalModificationProgramId",
          "type": "string",
          "map": "finalModificationProgramId"
        },
        {
          "name": "pageId",
          "type": "string",
          "map": "pageId"
        },
        {
          "name": "moduleCode",
          "type": "string",
          "map": "moduleCode"
        },
        {
          "name": "subModuleCode",
          "type": "string",
          "map": "subModuleCode"
        },
        {
          "name": "pageName",
          "type": "string",
          "map": "pageName"
        },
        {
          "name": "pageTitleMessageResourceId",
          "type": "string",
          "map": "pageTitleMessageResourceId"
        },
        {
          "name": "pageTypeCode",
          "type": "string",
          "map": "pageTypeCode"
        },
        {
          "name": "pageDestinationValue",
          "type": "string",
          "map": "pageDestinationValue"
        },
        {
          "name": "pageStatusCode",
          "type": "string",
          "map": "pageStatusCode"
        },
        {
          "name": "pageBlockContent",
          "type": "string",
          "map": "pageBlockContent"
        },
        {
          "name": "pageUseYn",
          "type": "string",
          "map": "pageUseYn"
        },
        {
          "name": "pageUsePriodYn",
          "type": "string",
          "map": "pageUsePriodYn"
        },
        {
          "name": "pageUsePriodStartDatetime",
          "type": "string",
          "map": "pageUsePriodStartDatetime"
        },
        {
          "name": "pageUsePriodFinishDatetime",
          "type": "string",
          "map": "pageUsePriodFinishDatetime"
        },
        {
          "name": "pagePopupYn",
          "type": "string",
          "map": "pagePopupYn"
        },
        {
          "name": "pagePopupOptionValue",
          "type": "string",
          "map": "pagePopupOptionValue"
        },
        {
          "name": "searchPageCond",
          "type": "string",
          "map": "searchPageCond"
        },
        {
          "name": "searchPageText",
          "type": "string",
          "map": "searchPageText"
        },
        {
          "name": "lang",
          "type": "string",
          "map": "lang"
        },
        {
          "name": "rangeDate",
          "type": "string",
          "map": "rangeDate"
        },
        {
          "name": "buttonList",
          "type": "object",
          "map": "buttonList"
        },
        {
          "name": "state",
          "type": "object",
          "map": "state"
        },
        {
          "name": "dataset-row-id",
          "type": "string",
          "map": "dataset-row-id"
        },
      ]
    }],
    methods: {
      onClicked() {
        this.myToolTip = 'tooltip changed';
      },
      onCodeLoaded(optionsList) {
        optionsList.push({
          key: 'N',
          label: 'NN'
        });
      },
      datasetUpdate() {
        console.log('update');
      },
      onTestClicked() {
        this.dataset0.data[0]['pageId'] = 'TEST';
      },
      onRangeChanged(value) {
        console.log(this.rangeDate);
        console.log(value);
      },
      onGridButtonClicked(btn) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${btn.label}`, null);
      },
    }
  };
</script>
<style scoped></style>
